import type { Schema } from '@empathyco/x-adapter'
import type { HierarchicalFacet } from '@empathyco/x-types'

import { hierarchicalFilterSchema } from './hierarchical-filter.schema'

export const hierarchicalFacetSchema: Schema<any, HierarchicalFacet> = {
  modelName: () => 'HierarchicalFacet',
  id: 'facet',
  label: 'label',
  filters: {
    $path: 'values',
    $subSchema: hierarchicalFilterSchema,
    $context: { facetId: 'facet' },
  },
}
